module.exports = __webpack_public_path__ + "static/media/ico-instagram.61039e1c.svg";